import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6.00067 0.232178C6.00056 0.232178 6.00039 0.232178 6.00024 0.232178C2.81477 0.232178 0.232422 2.81452 0.232422 6C0.232422 9.18534 2.81452 11.7676 5.99979 11.7678C6.00007 11.7678 6.00034 11.7678 6.00064 11.7678C9.18554 11.7678 11.7675 9.18642 11.7685 6.00174V6C11.7685 2.81452 9.18612 0.232178 6.00064 0.232178H6.00067ZM6.84277 9.02479C6.82629 9.55873 6.43657 9.93116 5.89191 9.93116H5.85566C5.3069 9.91467 4.91881 9.51092 4.93527 8.96875C4.95012 8.43647 5.34725 8.04921 5.87789 8.04921L5.91086 8.05085C6.47529 8.06734 6.85843 8.46777 6.84194 9.02479H6.84277ZM8.20315 5.34493C8.0738 5.52786 7.79033 5.7569 7.43191 6.03542L7.03639 6.30733C6.82053 6.47541 6.69032 6.63528 6.64173 6.79018C6.60218 6.91212 6.58405 6.9451 6.58074 7.19474V7.2582H5.0737L5.07783 7.13049C5.09678 6.60725 5.10997 6.29828 5.32667 6.04368C5.6678 5.64489 6.41925 5.16038 6.45058 5.13978C6.55359 5.0648 6.64338 4.97252 6.71672 4.86787C6.87492 4.64952 6.94412 4.47813 6.94412 4.31085C6.94412 4.07683 6.87574 3.85933 6.73812 3.66817C6.60628 3.48113 6.35579 3.388 5.99324 3.388C5.634 3.388 5.38762 3.50171 5.24012 3.73654C5.08851 3.97548 5.01186 4.22844 5.01186 4.48636V4.55063H3.4595L3.46197 4.48306C3.50234 3.53302 3.84182 2.8483 4.46969 2.44784C4.8652 2.19488 5.35794 2.06634 5.93141 2.06634C6.68123 2.06634 7.3165 2.24927 7.81502 2.60851C8.32177 2.97353 8.57802 3.51983 8.57802 4.23173C8.57802 4.62971 8.45195 5.00462 8.20311 5.34411L8.20315 5.34493Z"
        fill="#525358"
      />
    </svg>
  );
}

export default Icon;
